import { render, staticRenderFns } from "./VipInfoItem.vue?vue&type=template&id=dcaf9194&scoped=true&"
import script from "./VipInfoItem.vue?vue&type=script&lang=js&"
export * from "./VipInfoItem.vue?vue&type=script&lang=js&"
import style0 from "./VipInfoItem.vue?vue&type=style&index=0&id=dcaf9194&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcaf9194",
  null
  
)

export default component.exports